// @ts-strict-ignore
import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import { setAlert } from 'src/components/alert/actions';
import { showSignupModal, showModal } from 'src/modules/shared/modal/actions';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import i18n from 'src/utils/translate';
import { userHasPermission } from 'src/utils/context';
import ActionsDropdown from 'src/modules/community/singlePost/components/actionsDropdown';
import Button from 'src/components/buttons/button';
import LikeButton from 'src/components/buttons/likeButton';
import FollowButton from 'src/components/buttons/followButton/followButton';
import { ModalProps } from 'src/modules/shared/modal/components/report/reportModal';
import { ModalType } from 'src/constants/modalTypes';
import { Permission } from 'src/constants/types';
export default function PostActions({
  onReply
}: {
  onReply: () => void;
}): JSX.Element {
  const dispatch = useDispatch();
  const currentCommunity = useSelector(({
    context
  }) => context.currentCommunity);
  const currentUser = useSelector(({
    context
  }) => context.currentUser);
  const post = useSelector(({
    pages
  }) => pages.singlePost.post);
  const canReport = userHasPermission(currentUser, Permission.SendReportAbuse);
  const canFollow = currentUser && post.author.id !== currentUser?.userId && (
  // private post can only be followed by community members
  !post.isPrivate || post.isPrivate && currentUser?.isCommunityMemberOrHUStaff) && !post.isLocked;
  const onReplyClick = () => {
    if (!!onReply && !!currentUser) {
      if (!userHasPermission(currentUser, Permission.CreatePost)) {
        dispatch(setAlert(i18n.t(`You have been restricted in this community. Please contact this community's administrator to find out why.`)));
        return;
      }
      onReply();
    } else {
      trackFootfallEvent(Event.Clicked, {
        clickType: 'sign-up',
        clickMetadata: {
          section: Section.Post,
          element: Element.Reply
        }
      });
      dispatch(showSignupModal());
    }
  };
  const onReportClick = () => {
    if (currentUser) {
      trackFootfallEvent(Event.Clicked, {
        clickType: 'report',
        clickMetadata: {
          section: Section.Post
        }
      });
      const modalProps: ModalProps = {
        reportType: 'post',
        postId: post.id,
        communitySlug: currentCommunity?.slug,
        footfallSection: Section.Post
      };
      dispatch(showModal({
        modalType: ModalType.Report,
        modalProps
      }));
    } else {
      trackFootfallEvent(Event.Clicked, {
        clickType: 'sign-up',
        clickMetadata: {
          element: Element.Report,
          section: Section.Post
        }
      });
      dispatch(showSignupModal());
    }
  };
  return <Container data-sentry-element="Container" data-sentry-component="PostActions" data-sentry-source-file="postActions.tsx">
      {!post.isLocked && !currentCommunity.isArchived && (currentUser?.isCommunityMemberOrHUStaff || !currentUser) && <Button dataTestId="reply-button" size="sm" onClick={onReplyClick}>
          {i18n.t('Reply')}
        </Button>}
      <LikeButton post={post} signupContext={{
      section: Section.Post,
      element: Element.Like
    }} data-sentry-element="LikeButton" data-sentry-source-file="postActions.tsx" />
      {(canFollow || !currentUser) && <FollowButton clickMetadata={{
      section: Section.Post,
      element: Element.Follow
    }} dataTestId="save-button" followText={i18n.t('Save post')} followType="post" hasIcon={false} isFollowing={post.isFollowing} postId={post.id} size="sm" />}
      {(!currentUser || canReport) && <Button dataTestId="report-button" type="link" onClick={onReportClick}>
          {i18n.t('Report')}
        </Button>}
      {currentUser && <ActionsDropdown buttonText={i18n.t('More')} dataTestId="spp-more-dropdown" post={post} />}
    </Container>;
}
const Container = styled.div`
  line-height: 35px;
  padding: 12px 0;
  border-top: ${({
  theme
}) => theme.greyLine};
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media (${({
  theme
}) => theme.underScreenMedium}) {
    padding: 5px 0;
  }

  button {
    margin-right: 10px;
  }
`;